import { Wrench } from '@/components/icons'
import type { MaintenanceAircraft } from '../lib/hooks'

interface MaintenanceDayListProps {
  aircraft: MaintenanceAircraft[]
}

/**
 * Inline list of aircraft in maintenance for a given day. Renders nothing when
 * the list is empty. Used under the date header in the roster day drawer and the
 * roster list view.
 */
export function MaintenanceDayList({ aircraft }: MaintenanceDayListProps) {
  if (aircraft.length === 0) return null

  return (
    <div className="rounded-lg bg-background-notice-subtle p-3">
      <p className="text-xs font-semibold text-content-primary-subtle mb-2">In maintenance</p>
      <ul className="flex flex-col gap-2">
        {aircraft.map((a) => (
          <li key={a.id} className="flex items-center gap-2">
            <Wrench className="size-4 text-background-notice-bold shrink-0" />
            <span className="flex flex-col">
              <span className="text-sm font-medium text-content-primary-bold leading-tight">
                {a.registration}
              </span>
              <span className="text-xs text-content-primary-subtle leading-tight">
                Until {a.end.format('MMM D, YYYY')}
              </span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}
